export function getAllStates(stateRepository) {
  return stateRepository.getAll();
}